export class EInvoiceDeliveryDetailsDto {
  Name: string | null;
  Address: string | null;
  PostCode: string | null;
  City: string | null;
  Country: string | null;
  CountryAlpha2Code: string | null;
}

export class SaveDeliveryDetailsRequest extends EInvoiceDeliveryDetailsDto {
  constructor(deliveryDetails: EInvoiceDeliveryDetailsDto) {
    super();
    if (deliveryDetails != null) {
      this.Name = deliveryDetails.Name;
      this.Address = deliveryDetails.Address;
      this.City = deliveryDetails.City;
      this.Country = deliveryDetails.Country;
      this.CountryAlpha2Code = deliveryDetails.CountryAlpha2Code;
      this.PostCode = deliveryDetails.PostCode;
    }
  }
}

export class EInvoiceDelivery {
  IsCustomDelivery: boolean;
  DeliveryDate: Date | null;
  DeliveryDetails: EInvoiceDeliveryDetailsDto | null;
}
